<div *ngIf="(this.Mode === 'design') || (this.Mode === 'preview') || (this.Mode === 'instance')"
     class="{{this.CssClass}}">
    <span class="label-span">{{this.DisplayName}}</span>
</div>
